import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { supabase } from '../../lib/supabaseClient';

import { useAuth } from './AuthContext';

const ProtectedHostUpgradeRoute = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  // Email verification disabled for testing phase

  useEffect(() => {
    const checkSubscription = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        // Check subscription status
        const { data, error } = await supabase
          .from('host_subscriptions')
          .select('*')
          .eq('user_id', user.id)
          .eq('status', 'active')
          .order('created_at', { ascending: false })
          .limit(1)
          .maybeSingle();

        if (error) {
          console.error('Error checking subscription:', error);
        }

        setSubscription(data);
      } catch (err) {
        console.error('Error in subscription check:', err);
      } finally {
        setLoading(false);
      }
    };

    if (!authLoading) {
      checkSubscription();
    }
  }, [user, authLoading]);

  // Wait for auth and subscription checks to complete
  if (authLoading || loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
          color: '#666',
        }}
      >
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ returnUrl: location.pathname }} replace />;
  }

  // Redirect to dashboard if user already has an active subscription
  if (subscription) {
    return <Navigate to="/host" replace />;
  }

  // User is authenticated, email verified, and doesn't have an active subscription
  return children;
};

export default ProtectedHostUpgradeRoute;
